import type { FaireProductEntity } from "../../entity_types/product";

export const p_ymvueshsp3: FaireProductEntity = {
  token: "p_ymvueshsp3",
  type: "product",
  name: "NT12429SET-Mineral Washed Knit Casual Top & Shorts",
  brandToken: "b_8vpa7bbq6h",
  brandName: "VERY J",
  imageUrl: "https://cdn.faire.com/fastly/78f579a560558d13fc7c2bbd0d6d1639faf2665527c665f005e3c6e233febd86.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/45632a618bc9b64d712a0c78c254eeae33bdaf69c3251c3a0f646004ccde5a53.jpeg",
    "https://cdn.faire.com/fastly/9cbb3811fa6d8494dd80053330b3b776df4cdbc8c39c2b18c3507d57d9af2ccb.jpeg",
    "https://cdn.faire.com/fastly/39e263d9f6c051b8063730901546261be330bd2209e9f42d19c33980ec9497f2.jpeg",
    "https://cdn.faire.com/fastly/ad4dbdbd2bfa655cf58789fbf3321dadbdb6dad3e3a629ba0efacef6d901c1ac.jpeg",
    "https://cdn.faire.com/fastly/585adb57d8f032d5ce33002d9dd52cea867dfc6cbc17fdcb86c76a7a42a11b20.jpeg",
    "https://cdn.faire.com/fastly/d2bda1da86e9a90fdbfaa5364a96eb1a48460d594cb4905bd5c93957492c8928.jpeg",
    "https://cdn.faire.com/fastly/e091dea0cb6db971a936144b62e9f79fa4539b8b96da7483921631ffdbd1ed0a.jpeg",
    "https://cdn.faire.com/fastly/707f383bc6793e20a133074f77062ffb1db07e94d0174b6e28aec88ab09deffa.jpeg",
    "https://cdn.faire.com/fastly/7d7547f600c12f14768053f085f5e69ba363d2a87acac9ffd3962f3869aee258.jpeg",
    "https://cdn.faire.com/fastly/a6aa83826091d22fbe8bb86a5e3a49afc2c41403f5c09424331a512952ee33e7.jpeg",
    "https://cdn.faire.com/fastly/b370a25c7a88c0af36353b2ce6495d7db29458bed329d69a07855120c6e06fae.jpeg",
    "https://cdn.faire.com/fastly/2057217b3dd2c45b57875268318987a379a440c64c1c53756ba2069d2825cd37.jpeg",
    "https://cdn.faire.com/fastly/db6a39dce6a931658b28b05aaeefaf0a330c5e84db9ca0cae0fdc2428a2e0050.jpeg",
    "https://cdn.faire.com/fastly/af899985f47d8a372aa8282f922974c181f4d778cd33eaab9fd09e5e79b6ab0c.jpeg",
    "https://cdn.faire.com/fastly/233d317d45b373bc7f57c065f2ee4510bcf4d8093d2b7c2515508ba0c4e54511.jpeg",
    "https://cdn.faire.com/fastly/aa4d317fe422e66b6c8950cda2907b24a1ea9ccb67a7d7e1a13d7f8e88c6d182.jpeg",
    "https://cdn.faire.com/fastly/8f68398c717c8a9f2d3f2993bab849a4cd71ce9ffa207872552074f91628cdf7.jpeg",
    "https://cdn.faire.com/fastly/6ba2b379c1063ead0e89dc7564000ced8568a7dbe35af6916376d8e0f9cb1801.jpeg",
    "https://cdn.faire.com/fastly/477c63902d293980b433d01bf3669af8c64b4e0e8ba13321ef342f4b19cf6f87.jpeg",
    "https://cdn.faire.com/fastly/d8d803ce7136e745627563baa32140a23d98bc5155784ad880ad1f42536765c5.jpeg",
    "https://cdn.faire.com/fastly/4bca8e528b24167d31c78d62b2e2378ef3f942c26b7cf4cc5bdada6eefe2650e.jpeg",
    "https://cdn.faire.com/fastly/2306c1b86fdacbc886d1993cf3b0542e22d73639a9780c7e4ace355edc8c3f6f.jpeg",
    "https://cdn.faire.com/fastly/e1f25abec7cbb062d2d26a59052b6f0128c5da7d7715ea4fdd1224c5cb4a11d6.jpeg",
    "https://cdn.faire.com/fastly/6872874d6985b02f4f9356ed1d77814aac5aaeadf3646457a7894bb4f97c398c.jpeg",
    "https://cdn.faire.com/fastly/5e514a6747d41ad52fcbaa8a2fc3c2520a3d0cb26d52ebc7172987c0a6da52b1.jpeg",
    "https://cdn.faire.com/fastly/8853039e7d6da108887742963d33e551aafcc88bb549cff185e4f546ede03870.jpeg",
    "https://cdn.faire.com/fastly/537ffbed6ff875e92f3846fe01a8716f3b9a27b864e7881442af27c987598193.jpeg",
    "https://cdn.faire.com/fastly/eece8098671dfb2bab4f20c0735c1d81a339183dbf54be7cb420301553d95650.jpeg",
    "https://cdn.faire.com/fastly/67fc0e1c4120be1c74ddedad7170116d6c056d2c3fa47c969964abcd86e64bfe.jpeg",
    "https://cdn.faire.com/fastly/d3dd49865a41e06f62294c5b972eaa0e88f8e186c247e260658175f71830ac26.jpeg"
  ],
  priceDollars: 19.5,
  description: "**PLUS SIZE Search for NT12429SETX**\n\n- Mineral Washed Knit Casual Top & Shorts\n- Raw Edge Detail\n- Valentine's Day Outfit\n\nTOP\n- Oversized\n- Short Sleeve\n- Round Neck\n- Side Patch Pocket\n\nBOTTOM\n- Elastic Waist W/ Tie\n- Side Pockets\n\n(Model height: 5\"9\", wearing a Small, 2-2-2 Size Ratio, NEW IN)",
  tags: [],
  msrpDollars: 58.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:55:25.534Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
